module.exports = __webpack_public_path__ + "img/upload-file.93f20e5a.svg";